<template>
  <div>
    <AppLoadingContainer :predicate="isLoading">
      <div class="card-body">
        <div class="card">
          <div class="card-header bg-dark text-white">
            People Termination Discrepancies
          </div>
          <div class="card-body">
            <BTable :busy="isLoading"
                    :fields="peopleTerminationDiscrepanciesTableColumns"
                    :items="databasePeopleTerminationDiscrepancies"
                    :responsive="true"
                    primary-key="table"
                    show-empty
                    striped
                    table-class="table-align-middle">
            </BTable>
          </div>
        </div>
        <br>
        <div class="card">
          <div class="card-header bg-dark text-white">
            Title Discrepancies
          </div>
          <div class="card-body">
            <BTable :busy="isLoading"
                    :fields="titleDiscrepanciesTableColumns"
                    :items="databaseTitleDiscrepancies"
                    :responsive="true"
                    primary-key="titleCode"
                    show-empty
                    striped
                    table-class="table-align-middle">
            </BTable>
          </div>
        </div>
      </div>
    </AppLoadingContainer>
  </div>
</template>

<script>
import DatabaseStatisticsService from "@/services/DatabaseStatisticsService";
import AppLoadingContainer from "../shared/AppLoadingContainer";

export default {
  components: {
    AppLoadingContainer
  },
  data() {
    return {
      isLoading: true,
      databasePeopleTerminationDiscrepancies: [],
      databaseTitleDiscrepancies: [],
      peopleTerminationDiscrepanciesTableColumns: [
        {
          key: "fullName",
          label: "Name"
        },
        {
          key: "uin",
          label: "UIN"
        }
      ],
      titleDiscrepanciesTableColumns: [
        {
          key: "titleCode",
          label: "Title Code"
        }
      ]
    };
  },
  methods: {
    loadData() {
      DatabaseStatisticsService.getFAMISDBPeopleTerminationDiscrepanciesDatabaseStatistics()
        .then(response => {
          this.databasePeopleTerminationDiscrepancies = response;
          DatabaseStatisticsService.getFAMISDBTitleDiscrepanciesDatabaseStatistics()
            .then(innerResponse => {
              this.databaseTitleDiscrepancies = innerResponse;
            })
            .catch(() => {
              this.redirectToError();
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.redirectToError();
        });
    }
  },
  created() {
    this.loadData();
  }
};
</script>